import Vue from 'vue';
import VueRouter from 'vue-router';

import dbfunctions from './components/dbfunctions.vue';
import loginform from './components/loginform.vue';
import aboutus from './components/aboutus.vue';
import info_venue from './components/info_venue.vue';
import info_capetown from './components/info_capetown.vue';
import info_2017committee from './components/info_2017committee.vue';
import info_delegateregistration from './components/info_delegateregistration.vue';
import scregister from './components/scregister.vue';
import testpage from './components/testpage.vue';
import manageusers from './components/manageusers.vue';
import dynamic from './components/dynamic.vue';

Vue.use(VueRouter);

const routes = [ // must add params here for all prop data
  { path: '/', component: aboutus },
  { path: '/testpage', component: testpage },
  { path: '/scregister', component: scregister },
  { path: '/login', component: loginform },
  { path: '/info_venue', component: info_venue },
  { path: '/info_capetown', component: info_capetown },
  { path: '/info_2017committee', component: info_2017committee },
  { path: '/info_delegateregistration', component: info_delegateregistration },
  { path: '/manageusers', component: manageusers },
  { path: '/content/:cid', component: dynamic }
];

export default new VueRouter({
  routes,
  mode: 'history'
});



/** WEBPACK FOOTER **
 ** ./src/router.js
 **/